import { useCallback } from 'react';

import type { SelectedFilterValue } from '../../types';
import { useFilterState } from '../../hooks/useFilterState';

/** Represents the state and logic for having a filter selection popover and selecting a filter in the popover */
export function useFilterSettingsPopover(
  initiallySelectedFilterValues: SelectedFilterValue[] = [],
) {
  const {
    selectedFilterId,
    selectFilter: selectFilterInternal,
    ...rest
  } = useFilterState(initiallySelectedFilterValues);

  const isPopoverOpen = !!selectedFilterId;

  const closePopover = useCallback(() => {
    selectFilterInternal(undefined);
  }, [selectFilterInternal]);

  const selectFilter = useCallback(
    (filterId: string) => {
      if (filterId === selectedFilterId) {
        closePopover();
        return;
      }

      selectFilterInternal(filterId);
    },
    [selectedFilterId, closePopover, selectFilterInternal],
  );

  return {
    selectedFilterId,
    selectFilter,
    isPopoverOpen,
    closePopover,
    ...rest,
  };
}
